module.exports = __webpack_public_path__ + "static/media/26.be27df46.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/26.png
// module id = 1400
// module chunks = 0